const NOME_JANELA = "PrimeDiscadoraMesa";

let mesa: Window | null = null;

export function abrirMesaDiscadora(): Window | null {
  if (mesa && !mesa.closed) {
    try { mesa.focus(); } catch { return mesa; }
    return mesa;
  }

  const larguraDisponivel = window.screen.availWidth || window.innerWidth;
  const alturaDisponivel = window.screen.availHeight || window.innerHeight;
  const largura = Math.min(larguraDisponivel, Math.max(900, Math.round(larguraDisponivel * 0.86)));
  const altura = Math.min(alturaDisponivel, Math.max(700, Math.round(alturaDisponivel * 0.9)));
  const esquerda = Math.max(0, Math.round((larguraDisponivel - largura) / 2));
  const topo = Math.max(0, Math.round((alturaDisponivel - altura) / 2));

  mesa = window.open(
    "/mesa-prime-app/",
    NOME_JANELA,
    `popup=yes,width=${largura},height=${altura},left=${esquerda},top=${topo},resizable=yes,scrollbars=no`,
  );
  try { mesa?.focus(); } catch { return mesa; }
  return mesa;
}

export function focarMesaDiscadora(): boolean {
  if (!mesa || mesa.closed) return false;
  try {
    mesa.focus();
    return true;
  } catch {
    return false;
  }
}
